import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { ContractDesignerEditorStoreContext } from './contexts/StoreContext'
import { createContractDesignerEditorStore } from './store/createStore'

export const ContractDesignerEditorStoreProvider = ({
  children
}: PropsWithChildren) => {
  const store = useCreation(() => createContractDesignerEditorStore(), [])

  return (
    (<ContractDesignerEditorStoreContext value={store}>
      {children}
    </ContractDesignerEditorStoreContext>)
  );
}
